import { MAX_LOCK_HOURS, describeLockWindow } from '../../utils/signupLock';

/**
 * When parents stop being able to change a booking.
 *
 * On, a parent cannot book, move or cancel a slot from this many hours before it starts — the
 * database refuses it, not just the page. The office can still change anything from here, the
 * registrations page, or the CLI. Off is how every round worked before this existed: changes
 * right up to the start time.
 */
export function SignupLockEditor({
  lockEnabled,
  lockHoursBefore,
  onChange,
  idPrefix,
}: {
  lockEnabled: boolean;
  lockHoursBefore: number;
  onChange: (patch: { lockEnabled?: boolean; lockHoursBefore?: number }) => void;
  idPrefix: string;
}) {
  const checkboxId = `${idPrefix}-lock-enabled`;
  const hoursId = `${idPrefix}-lock-hours`;
  const validHours = Number.isInteger(lockHoursBefore) && lockHoursBefore >= 0 && lockHoursBefore <= MAX_LOCK_HOURS;

  return (
    <div className="space-y-2">
      <div className="flex items-center">
        <input
          type="checkbox"
          id={checkboxId}
          checked={lockEnabled}
          onChange={(e) => onChange({ lockEnabled: e.target.checked })}
          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
        />
        <label htmlFor={checkboxId} className="ml-2 text-sm font-medium text-gray-700">
          Lock changes before each meeting
        </label>
      </div>

      {lockEnabled && (
        <div className="ml-6 space-y-1">
          <div className="flex items-center gap-2 text-sm text-gray-700">
            <input
              type="number"
              id={hoursId}
              min={0}
              max={MAX_LOCK_HOURS}
              step={1}
              required
              value={Number.isFinite(lockHoursBefore) ? lockHoursBefore : ''}
              onChange={(e) => onChange({ lockHoursBefore: e.target.value === '' ? Number.NaN : Number(e.target.value) })}
              className="w-20 border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <label htmlFor={hoursId}>hours before the meeting starts</label>
          </div>
          <p className="text-xs text-gray-500">
            {validHours
              ? `From ${describeLockWindow(lockHoursBefore)} before a slot, parents can't book, change or cancel it themselves. Admins still can.`
              : `Enter a whole number of hours from 0 to ${MAX_LOCK_HOURS}.`}
          </p>
        </div>
      )}
    </div>
  );
}
